enum IFileSubRoleEnum {
  IMAGE = 'IMAGE',
  PANORAMIC_IMAGE = 'PANORAMIC_IMAGE',
  OCT_VIP = 'OCT_VIP',
  FA = 'FA',
}

export default IFileSubRoleEnum;
